/** User-provided mark at public/icons/reef-logo.svg (kept on disk; in-app UI uses PNG icons). */
export const REEF_LOGO_SVG_SRC = `${import.meta.env.BASE_URL}icons/reef-logo.svg`;

export const APP_DISPLAY_NAME = "Bino's Reef";

/** Theme PNG icons (reef-icon-light-* / reef-icon-dark-*). */
export function reefIconPngSrc(mode, pixelSize = 32) {
  const theme = mode === 'dark' ? 'dark' : 'light';
  const sizes = [16, 32, 180, 192, 256, 512];
  const pick = sizes.find((s) => s >= pixelSize) ?? 512;
  return `${import.meta.env.BASE_URL}icons/reef-icon-${theme}-${pick}.png`;
}
